<template>
  <router-view></router-view>
</template>
<script>

import RegisterStoreModule from "@/mixins/RegisterStoreModule"
import invoiceStore from "./store.js"

export default {
  name: "invoice",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("invoice", invoiceStore)
  },
}
</script>
